import { useCallback, useMemo } from "react"
import { BaseVirtualizedTable } from "./BaseVirtualizedTable"
import { InfiniteScrollingTableProps } from "./types"

export function InfiniteScrollingTable<TData>({
  infiniteQueryResult,
  ...baseProps
}: InfiniteScrollingTableProps<TData>) {
  const { data, fetchNextPage, isFetching, isLoading, hasNextPage } =
    infiniteQueryResult

  // Flatten the array of arrays from useInfiniteQuery.
  const flatData = useMemo(
    () => data?.pages?.flatMap((page) => page.data) ?? [],
    [data]
  )
  const totalDBRowCount = data?.pages?.[0]?.totalCount ?? 0
  const totalFetched = flatData.length

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement: HTMLDivElement) => {
      const { scrollHeight, scrollTop, clientHeight } = containerRefElement
      if (
        scrollHeight - scrollTop - clientHeight < 500 &&
        !isFetching &&
        hasNextPage
      ) {
        fetchNextPage()
      }
    },
    [fetchNextPage, isFetching, totalFetched, totalDBRowCount]
  )

  return (
    <BaseVirtualizedTable
      {...baseProps}
      data={flatData}
      isLoading={isLoading}
      onTableScroll={fetchMoreOnBottomReached}
    />
  )
}
